<div class="help-dialog">
  <div class="dialog-header">
    <h2 mat-dialog-title>Help & Documentation</h2>
    <button mat-icon-button (click)="onClose()" class="close-button">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="help-dialog-content">
    <div class="help-layout">
      <!-- Sidebar with Help Topics -->
      <div class="help-sidebar">
        <div class="sidebar-header-background">
          <h3>Help Topics</h3>
        </div>
        
        <div class="topics-list">
          <div 
            class="card-selectable topic-item"
            [class.selected]="selectedTopic === 'data-profiler'"
            (click)="onTopicSelect('data-profiler')">
            <mat-icon svgIcon="chart-blue" class="topic-icon"></mat-icon>
            <div class="topic-info">
              <div class="topic-name">Data Assessment</div>
              <div class="topic-description">Analyse and understand your data</div>
            </div>
          </div>

          <div 
            class="card-selectable topic-item"
            [class.selected]="selectedTopic === 'anomaly-detection'"
            (click)="onTopicSelect('anomaly-detection')">
            <mat-icon svgIcon="radar-ai-blue" class="topic-icon"></mat-icon>
            <div class="topic-info">
              <div class="topic-name">Detect Anomalies</div>
              <div class="topic-description">AI-powered anomaly identification</div>
            </div>
          </div>

          <div
            class="card-selectable topic-item"
            [class.selected]="selectedTopic === 'ai-readiness'"
            (click)="onTopicSelect('ai-readiness')">
            <mat-icon svgIcon="ai-brain-idea-blue" class="topic-icon"></mat-icon>
            <div class="topic-info">
              <div class="topic-name">AI Readiness</div>
              <div class="topic-description">Assess suitability for AI and machine learning</div>
            </div>
          </div>

          <div 
            class="card-selectable topic-item"
            [class.selected]="selectedTopic === 'project-canvas'"
            (click)="onTopicSelect('project-canvas')">
            <mat-icon svgIcon="ai-scan-blue" class="topic-icon"></mat-icon>
            <div class="topic-info">
              <div class="topic-name">Clean Data</div>
              <div class="topic-description">Create and manage data quality workflows</div>
            </div>
          </div>

          <!-- HYPOTHESIS TESTING - COMMENTED OUT -->
          <!-- <div 
            class="card-selectable topic-item"
            [class.selected]="selectedTopic === 'hypothesis-testing'"
            (click)="onTopicSelect('hypothesis-testing')">
            <mat-icon svgIcon="ai-brain-idea-blue" class="topic-icon"></mat-icon>
            <div class="topic-info">
              <div class="topic-name">Hypothesis Testing</div>
              <div class="topic-description">Statistical hypothesis tests</div>
            </div>
          </div> -->
        </div>
      </div>
      
      <!-- Main Content Area -->
      <div class="content-wrapper-parent">
        <div class="content-wrapper">
          <div class="help-content">
            <div class="page-header">
              @if (selectedTopic === 'project-canvas') {
                <mat-icon svgIcon="ai-scan-blue" class="header-icon"></mat-icon>
                <h1>Clean Data</h1>
              }
              @if (selectedTopic === 'data-profiler') {
                <mat-icon svgIcon="chart-blue" class="header-icon"></mat-icon>
                <h1>Data Assessment</h1>
              }
              @if (selectedTopic === 'anomaly-detection') {
                <mat-icon svgIcon="radar-ai-blue" class="header-icon"></mat-icon>
                <h1>Detect Anomalies</h1>
              }
              @if (selectedTopic === 'ai-readiness') {
                <mat-icon svgIcon="ai-brain-idea-blue" class="header-icon"></mat-icon>
                <h1>AI Readiness</h1>
              }
              <!-- HYPOTHESIS TESTING - COMMENTED OUT -->
              <!-- @if (selectedTopic === 'hypothesis-testing') {
                <mat-icon svgIcon="ai-brain-idea-blue" class="header-icon"></mat-icon>
                <h1>Hypothesis Testing</h1>
              } -->
            </div>

            <!-- Clean Data Section -->
            @if (selectedTopic === 'project-canvas') {
            <div class="help-section">
              <div class="section-content">
                <p class="section-description">
                  Clean Data is your central workspace for data quality projects. Create, configure, and manage 
                  end-to-end data cleaning workflows that ensure your data meets quality standards.
                </p>

                <div class="info-sections-wrapper">
                  <div class="info-overview-section">
                    <h3>Best Use Cases</h3>
                    <div class="feature-list">
                      <div class="feature-item">
                        <div>
                          <strong>Inconsistent Formats</strong>
                          <p>Correct inconsistent data formats across your datasets</p>
                        </div>
                      </div>
                      <div class="feature-item">
                        <div>
                          <strong>Duplicates & Missing Values</strong>
                          <p>Remove duplicates and handle missing values effectively</p>
                        </div>
                      </div>
                      <div class="feature-item">
                        <div>
                          <strong>Data Standardisation</strong>
                          <p>Standardise data for downstream analysis and reporting</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="info-overview-section">
                    <h3>Expected Outcomes</h3>
                    <div class="feature-list">
                      <div class="feature-item">
                        <div>
                          <strong>AI-Powered Workflows</strong>
                          <p>Intelligent data transformation workflows tailored to your needs</p>
                        </div>
                      </div>
                      <div class="feature-item">
                        <div>
                          <strong>Automated Processes</strong>
                          <p>Automated cleaning and validation processes that save time</p>
                        </div>
                      </div>
                      <div class="feature-item">
                        <div>
                          <strong>Clean Datasets</strong>
                          <p>Clean, validated datasets ready for immediate use</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="info-overview-section">
                    <h3>Key Benefits</h3>
                    <div class="feature-list">
                      <div class="feature-item">
                        <div>
                          <strong>Save Time</strong>
                          <p>Reduce manual data cleaning time by up to 80%</p>
                        </div>
                      </div>
                      <div class="feature-item">
                        <div>
                          <strong>Ensure Consistency</strong>
                          <p>Maintain consistency across your entire data workflow</p>
                        </div>
                      </div>
                      <div class="feature-item">
                        <div>
                          <strong>Track & Audit</strong>
                          <p>Complete tracking and auditing of all cleaning operations</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <mat-expansion-panel class="help-expansion-panel">
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      <mat-icon class="panel-icon" svgIcon="play-blue"></mat-icon>
                      Getting Started
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <ol class="help-list">
                    <li><span class="list-label">Create a Project:</span> From the <strong>Homepage</strong> (<mat-icon svgIcon="home-dark-grey" class="inline-icon"></mat-icon>), click <strong>Clean Data</strong> (<mat-icon svgIcon="ai-scan-blue" class="inline-icon"></mat-icon>), upload or select a data source, and click Go (<mat-icon svgIcon="arrow-right-square-grey" class="inline-icon"></mat-icon>)</li>
                    <li><span class="list-label">Set Goals:</span> Define what you want to achieve with your data quality project. Optionally fine tune cleaning, validation, and transformation tasks.</li>
                    <li><span class="list-label">Specify Output:</span> Choose where your cleaned data will be saved or exported to.</li>
                    <li><span class="list-label">Execute Workflow:</span> Run your project (<mat-icon svgIcon="play_circle" class="inline-icon"></mat-icon>) and monitor real-time progress.</li>
                    <li><span class="list-label">Review Results:</span> Analyse outputs and iterate on your configuration.</li>
                  </ol>
                </mat-expansion-panel>

                <mat-expansion-panel class="help-expansion-panel">
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      <mat-icon class="panel-icon" svgIcon="lightbulb-blue"></mat-icon>
                      Tips & Best Practices
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <ul class="help-list">
                    <li>Previously created Cleaning Workflows are saved to your <strong>Activity</strong> (<mat-icon svgIcon="docs-dark-grey" class="inline-icon"></mat-icon>)</li>
                    <li>Always set clear goals before configuring tasks to ensure focused data quality improvements.</li>
                    <li>Review the data assessment before defining cleaning rules to understand your data better.</li>
                    <li>Use descriptive names for workflows to easily identify them later.</li>
                    <li>Start with a small sample dataset to test your workflow configuration.</li>
                    <li>Monitor task execution regularly to ensure they're performing as expected.</li>
                    <li>Document your cleaning rules and transformations for future reference.</li>
                  </ul>
                </mat-expansion-panel>

                <h3>Key Features</h3>
                <div class="feature-list feature-grid">
                  <div class="feature-item">
                    <div>
                      <strong>Data Source Management</strong>
                      <p>Easily add, remove, or switch between data sources for your project.</p>
                    </div>
                  </div>
                  
                  <div class="feature-item">
                    <div>
                      <strong>Goal Setting</strong>
                      <p>Define specific quality goals and metrics you want to achieve.</p>
                    </div>
                  </div>
                  
                  <div class="feature-item">
                    <div>
                      <strong>Task Configuration</strong>
                      <p>Configure automated tasks to clean, validate, and transform your data.</p>
                    </div>
                  </div>
                  
                  <div class="feature-item">
                    <div>
                      <strong>Execution & Monitoring</strong>
                      <p>Run your project and monitor progress with real-time status updates.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            }

            <!-- Data Profiler Section -->
            @if (selectedTopic === 'data-profiler') {
            <div class="help-section">
              <div class="section-content">
                <p class="section-description">
                  The Data Assessment provides comprehensive insights into your data's structure, quality, and 
                  characteristics. It automatically analyses your datasets to help you understand patterns, 
                  identify issues, and make informed decisions about data quality.
                </p>

                <div class="info-sections-wrapper">
                  <div class="info-overview-section">
                    <h3>Best Use Cases</h3>
                    <div class="feature-list">
                      <div class="feature-item">
                        <div>
                          <strong>New Dataset Exploration</strong>
                          <p>Understand new datasets thoroughly before analysis</p>
                        </div>
                      </div>
                      <div class="feature-item">
                        <div>
                          <strong>Quality Issues</strong>
                          <p>Identify data quality issues and missing values quickly</p>
                        </div>
                      </div>
                      <div class="feature-item">
                        <div>
                          <strong>Documentation</strong>
                          <p>Document data structure for compliance and stakeholders</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="info-overview-section">
                    <h3>Expected Outcomes</h3>
                    <div class="feature-list">
                      <div class="feature-item">
                        <div>
                          <strong>Statistical Summary</strong>
                          <p>Detailed statistical summary of all columns in your data</p>
                        </div>
                      </div>
                      <div class="feature-item">
                        <div>
                          <strong>Visual Distributions</strong>
                          <p>Visual distributions and intelligent pattern detection</p>
                        </div>
                      </div>
                      <div class="feature-item">
                        <div>
                          <strong>Quality Score</strong>
                          <p>Data quality score with option to generate cleaning workflow</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="info-overview-section">
                    <h3>Key Benefits</h3>
                    <div class="feature-list">
                      <div class="feature-item">
                        <div>
                          <strong>Save Time</strong>
                          <p>Save hours of manual data exploration and investigation</p>
                        </div>
                      </div>
                      <div class="feature-item">
                        <div>
                          <strong>Early Detection</strong>
                          <p>Catch data issues before they impact your analysis</p>
                        </div>
                      </div>
                      <div class="feature-item">
                        <div>
                          <strong>Quality Reports</strong>
                          <p>Generate shareable quality reports for your team</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <mat-expansion-panel class="help-expansion-panel">
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      <mat-icon class="panel-icon" svgIcon="play-blue"></mat-icon>
                      Getting Started
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <ol class="help-list">
                    <li><span class="list-label">Access the Assessment:</span> From the <strong>Homepage</strong> (<mat-icon svgIcon="home-dark-grey" class="inline-icon"></mat-icon>), click <strong>Data Assessment</strong> (<mat-icon svgIcon="chart-blue" class="inline-icon"></mat-icon>) and upload or select a data source, and click <strong>Go</strong> (<mat-icon svgIcon="arrow-right-square-grey" class="inline-icon"></mat-icon>)</li>
                    <li><span class="list-label">View Statistics:</span> Review the automatically generated statistics for each column and data distributions through visualisations.</li>
                    <li><span class="list-label">Identify Issues:</span> Look for quality issues highlighted by the assessment.</li>
                  
                  </ol>
                </mat-expansion-panel>

                <mat-expansion-panel class="help-expansion-panel">
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      <mat-icon class="panel-icon" svgIcon="lightbulb-blue"></mat-icon>
                      Tips & Best Practices
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <ul class="help-list">
                    <li>Previously created assessments can be saved to your <strong>Activity</strong> (<mat-icon svgIcon="docs-dark-grey" class="inline-icon"></mat-icon>)</li>
                    <li>Review the automatically generated statistics for each column before drawing conclusions.</li>
                    <li>Pay attention to data quality indicators like completeness and uniqueness.</li>
                    <li>Use the data preview to understand actual values and patterns in your dataset.</li>
                    <li>Compare distributions across different columns to identify relationships.</li>
                    <li>Look for unexpected patterns or anomalies that might indicate data quality issues.</li>
                    <li>Upload a subset of your dataset with fewer columns to save processing time and reduce costs.</li>
                  </ul>
                </mat-expansion-panel>

                <mat-expansion-panel class="help-expansion-panel">
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      <mat-icon class="panel-icon" svgIcon="metrics-blue"></mat-icon>
                      Key Metrics
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <ul class="help-list">
                    <li><span class="list-label">Completeness:</span> Percentage of non-null values in each column.</li>
                    <li><span class="list-label">Uniqueness:</span> Number and percentage of unique values to identify duplicates.</li>
                    <li><span class="list-label">Type Detection:</span> Automatically detected data types and format patterns.</li>
                    <li><span class="list-label">Value Ranges:</span> Min/max values for numeric data, length ranges for text.</li>
                    <li><span class="list-label">Pattern Analysis:</span> Common patterns and anomalies in your data.</li>
                  </ul>
                </mat-expansion-panel>

                <h3>Data Quality Insights</h3>
                <div class="feature-list feature-grid">
                  <div class="feature-item">
                    <div>
                      <strong>Column Statistics</strong>
                      <p>Count, unique values, missing data, data types, and more for each column.</p>
                    </div>
                  </div>
                  
                  <div class="feature-item">
                    <div>
                      <strong>Data Distributions</strong>
                      <p>Histograms and frequency charts showing how your data is distributed.</p>
                    </div>
                  </div>
                  
                  <div class="feature-item">
                    <div>
                      <strong>Quality Indicators</strong>
                      <p>Flags for missing values, outliers, inconsistencies, and other quality concerns.</p>
                    </div>
                  </div>
                  
                  <div class="feature-item">
                    <div>
                      <strong>Data Preview</strong>
                      <p>Sample rows from your dataset to understand the actual data values.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            }

            <!-- AI Readiness Section -->
            @if (selectedTopic === 'ai-readiness') {
            <div class="help-section">
              <div class="section-content">
                <p class="section-description">
                  AI Readiness assesses whether your data is suitable for AI and machine learning. It produces
                  headline scores, supporting evidence, and practical next steps for improving model readiness.
                </p>

                <div class="info-sections-wrapper">
                  <div class="info-overview-section">
                    <h3>Best Use Cases</h3>
                    <div class="feature-list">
                      <div class="feature-item"><div><strong>Model Preparation</strong><p>Assess datasets before building AI or machine learning models</p></div></div>
                      <div class="feature-item"><div><strong>Dataset Comparison</strong><p>Compare the readiness of multiple candidate datasets</p></div></div>
                      <div class="feature-item"><div><strong>Improvement Planning</strong><p>Prioritise data improvements before model development</p></div></div>
                    </div>
                  </div>

                  <div class="info-overview-section">
                    <h3>Expected Outcomes</h3>
                    <div class="feature-list">
                      <div class="feature-item"><div><strong>Readiness Scores</strong><p>Headline scores across key data quality and suitability metrics</p></div></div>
                      <div class="feature-item"><div><strong>Evidence</strong><p>Clear evidence showing data strengths, gaps, and risks</p></div></div>
                      <div class="feature-item"><div><strong>Next Steps</strong><p>Practical recommendations to improve model readiness</p></div></div>
                    </div>
                  </div>

                  <div class="info-overview-section">
                    <h3>Key Benefits</h3>
                    <div class="feature-list">
                      <div class="feature-item"><div><strong>Make Better Decisions</strong><p>Understand whether data is suitable before investing in modelling</p></div></div>
                      <div class="feature-item"><div><strong>Reduce Rework</strong><p>Identify avoidable data issues early in the development process</p></div></div>
                      <div class="feature-item"><div><strong>Build a Plan</strong><p>Use evidence-based findings to guide data improvement work</p></div></div>
                    </div>
                  </div>
                </div>

                <mat-expansion-panel class="help-expansion-panel">
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      <mat-icon class="panel-icon" svgIcon="play-blue"></mat-icon>
                      Getting Started
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <ol class="help-list">
                    <li><span class="list-label">Select Data:</span> From the <strong>Homepage</strong>, click <strong>AI Readiness</strong> and select one or more data sources.</li>
                    <li><span class="list-label">Configure the Check:</span> Choose a timestamp column, the columns to assess, a project type, and a use case.</li>
                    <li><span class="list-label">Run the Assessment:</span> Start the check and wait for the readiness analysis to complete.</li>
                    <li><span class="list-label">Review Results:</span> Use the headline scores, evidence, and recommendations to plan your next steps.</li>
                  </ol>
                </mat-expansion-panel>
              </div>
            </div>
            }

            <!-- Anomaly Detection Section -->
            @if (selectedTopic === 'anomaly-detection') {
            <div class="help-section">
              <div class="section-content">
                <p class="section-description">
                  Anomaly Detection uses advanced statistical and machine learning algorithms to identify unusual patterns, 
                  outliers, and anomalies in your data. Choose from multiple detection methods optimised for different 
                  data types and complexity levels to uncover hidden quality issues.
                </p>

                <div class="info-sections-wrapper">
                  <div class="info-overview-section">
                    <h3>Best Use Cases</h3>
                    <div class="feature-list">
                      <div class="feature-item">
                        <div>
                          <strong>Fraud Detection</strong>
                          <p>Identify fraudulent patterns in transaction data</p>
                        </div>
                      </div>
                      <div class="feature-item">
                        <div>
                          <strong>Quality Monitoring</strong>
                          <p>Monitor quality in manufacturing or operational processes</p>
                        </div>
                      </div>
                      <div class="feature-item">
                        <div>
                          <strong>Trend Analysis</strong>
                          <p>Identify unusual trends in time-series data</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="info-overview-section">
                    <h3>Expected Outcomes</h3>
                    <div class="feature-list">
                      <div class="feature-item">
                        <div>
                          <strong>Flagged Records</strong>
                          <p>Anomalous records flagged with severity scores</p>
                        </div>
                      </div>
                      <div class="feature-item">
                        <div>
                          <strong>Visual Highlighting</strong>
                          <p>Visual highlighting of unusual patterns in your data</p>
                        </div>
                      </div>
                      <div class="feature-item">
                        <div>
                          <strong>Detailed Analysis</strong>
                          <p>Comprehensive analysis of why items are flagged</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="info-overview-section">
                    <h3>Key Benefits</h3>
                    <div class="feature-list">
                      <div class="feature-item">
                        <div>
                          <strong>Prevent Issues</strong>
                          <p>Catch critical issues before they cause problems</p>
                        </div>
                      </div>
                      <div class="feature-item">
                        <div>
                          <strong>Automate Monitoring</strong>
                          <p>Set up automated ongoing data monitoring processes</p>
                        </div>
                      </div>
                      <div class="feature-item">
                        <div>
                          <strong>Intelligent Scoring</strong>
                          <p>Reduce false positives with intelligent scoring algorithms</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <mat-expansion-panel class="help-expansion-panel">
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      <mat-icon class="panel-icon" svgIcon="play-blue"></mat-icon>
                      Getting Started
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <ol class="help-list">
                    <li><span class="list-label">Access Detection:</span> From the <strong>Homepage</strong> (<mat-icon svgIcon="home-dark-grey" class="inline-icon"></mat-icon>), click <strong>Anomaly Detection</strong> (<mat-icon svgIcon="radar-ai-blue" class="inline-icon"></mat-icon>) and upload or select a data source, and click Go (<mat-icon svgIcon="arrow-right-square-grey" class="inline-icon"></mat-icon>)</li>
                    <li><span class="list-label">Choose Method:</span> Select from <strong>Simple</strong>, <strong>Moderate</strong>, or <strong>Advanced</strong> detection algorithms based on your needs.</li>
                    <li><span class="list-label">Configure Parameters:</span> Select columns to scan for anomalies, and optionally adjust method-specific settings like sensitivity and thresholds.</li>
                    <li><span class="list-label">Run Detection:</span> Execute the analysis (<mat-icon svgIcon="play_circle" class="inline-icon"></mat-icon>) to identify anomalies in your dataset.</li>
                    <li><span class="list-label">Review Results:</span> Examine detected anomalies with detailed reports and visualisations.</li>
                  </ol>
                </mat-expansion-panel>

                <mat-expansion-panel class="help-expansion-panel">
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      <mat-icon class="panel-icon" svgIcon="lightbulb-blue"></mat-icon>
                      Tips & Best Practices
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <ul class="help-list">
                    <li>Previous Anomaly Detection Reports can be saved to your <strong>Activity</strong> (<mat-icon svgIcon="docs-dark-grey" class="inline-icon"></mat-icon>)</li>
                    <li>Start with Simple methods to get quick insights, then progress to Advanced if needed.</li>
                    <li>Review method descriptions to understand which algorithm fits your data characteristics.</li>
                    <li>Adjust parameters incrementally to fine-tune detection sensitivity.</li>
                    <li>Compare results from different methods to validate findings.</li>
                    <li>Use Advanced Settings only when you understand the method's requirements.</li>
                    <li>Document anomalies found for tracking and remediation planning.</li>
                  </ul>
                </mat-expansion-panel>

                <h3>Detection Methods</h3>
                <div class="feature-list feature-grid">
                  <div class="feature-item">
                    <div>
                      <strong>Simple Methods</strong>
                      <p>Quick statistical approaches ideal for initial exploration and basic outlier detection.</p>
                    </div>
                  </div>
                  
                  <div class="feature-item">
                    <div>
                      <strong>Moderate Methods</strong>
                      <p>Intermediate algorithms with configurable parameters for more nuanced detection.</p>
                    </div>
                  </div>
                  
                  <div class="feature-item">
                    <div>
                      <strong>Advanced Methods</strong>
                      <p>Sophisticated machine learning techniques for complex pattern recognition.</p>
                    </div>
                  </div>
                  
                  <div class="feature-item">
                    <div>
                      <strong>Custom Configuration</strong>
                      <p>Fine-tune detection with method-specific parameters and advanced settings.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            }

            <!-- HYPOTHESIS TESTING - COMMENTED OUT -->
            <!-- @if (selectedTopic === 'hypothesis-testing') {
            <div class="help-section">
              <div class="section-content">
                <p class="section-description">
                  Hypothesis Testing allows you to perform statistical tests on your data to validate assumptions, 
                  compare groups, and make data-driven decisions. Choose from a variety of statistical tests to 
                  analyse relationships, differences, and patterns in your datasets.
                </p>

                <h3>Testing Capabilities</h3>
                <div class="feature-list feature-grid">
                  <div class="feature-item">
                    <div>
                      <strong>Multiple Test Types</strong>
                      <p>Access various statistical tests including t-tests, ANOVA, chi-square, and correlation tests.</p>
                    </div>
                  </div>
                  
                  <div class="feature-item">
                    <div>
                      <strong>Flexible Data Input</strong>
                      <p>Upload files or manually enter data values for quick hypothesis testing.</p>
                    </div>
                  </div>
                  
                  <div class="feature-item">
                    <div>
                      <strong>Parameter Configuration</strong>
                      <p>Customize test parameters like significance level, alternative hypothesis, and test-specific settings.</p>
                    </div>
                  </div>
                  
                  <div class="feature-item">
                    <div>
                      <strong>Comprehensive Results</strong>
                      <p>View detailed test statistics, p-values, confidence intervals, and interpretation guidance.</p>
                    </div>
                  </div>
                </div>

                <mat-expansion-panel class="help-expansion-panel">
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      <mat-icon class="panel-icon" svgIcon="play-blue"></mat-icon>
                      Getting Started
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <ol class="help-list">
                    <li><span class="list-label">Access Testing:</span> From the <strong>Homepage</strong> (<mat-icon svgIcon="home-dark-grey" class="inline-icon"></mat-icon>), click <strong>Hypothesis Testing</strong> (<mat-icon svgIcon="ai-brain-idea-blue" class="inline-icon"></mat-icon>) to begin.</li>
                    <li><span class="list-label">Provide Data:</span> Upload a file or manually enter comma-separated values for your test data.</li>
                    <li><span class="list-label">Select Test:</span> Choose the appropriate statistical test from the available methods.</li>
                    <li><span class="list-label">Configure Parameters:</span> Adjust test-specific settings and parameters as needed (expand Advanced Settings for full control).</li>
                    <li><span class="list-label">Run Test:</span> Execute the hypothesis test (<mat-icon svgIcon="play_circle" class="inline-icon"></mat-icon>) to analyse your data.</li>
                    <li><span class="list-label">Interpret Results:</span> Review test statistics, p-values, and conclusions to make informed decisions.</li>
                  </ol>
                </mat-expansion-panel>

                <mat-expansion-panel class="help-expansion-panel">
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      <mat-icon class="panel-icon" svgIcon="lightbulb-blue"></mat-icon>
                      Tips & Best Practices
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <ul class="help-list">
                    <li>Choose the statistical test that matches your data type and research question.</li>
                    <li>For manual data entry, use comma-separated values (e.g., 1.2, 3.4, 5.6).</li>
                    <li>When uploading files, ensure column names are clear and data is properly formatted.</li>
                    <li>Review method descriptions to understand assumptions and requirements for each test.</li>
                    <li>Check that your data meets the assumptions of the chosen statistical test.</li>
                    <li>Use the default parameter values unless you have specific requirements.</li>
                    <li>Consider the significance level (alpha) carefully - 0.05 is standard for most applications.</li>
                    <li>Document your hypothesis, test choice, and results for reproducibility.</li>
                  </ul>
                </mat-expansion-panel>

                <mat-expansion-panel class="help-expansion-panel">
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      <mat-icon class="panel-icon" svgIcon="metrics-blue"></mat-icon>
                      Understanding Results
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <ul class="help-list">
                    <li><span class="list-label">P-value:</span> Probability of obtaining results at least as extreme as observed, assuming null hypothesis is true. Lower values indicate stronger evidence against the null hypothesis.</li>
                    <li><span class="list-label">Test Statistic:</span> The calculated value from your test (e.g., t-value, F-value, chi-square). Compare to critical values or use p-value for interpretation.</li>
                    <li><span class="list-label">Significance Level:</span> Threshold (typically 0.05) for determining statistical significance. If p-value < alpha, reject the null hypothesis.</li>
                    <li><span class="list-label">Confidence Intervals:</span> Range of values likely to contain the true parameter with specified confidence (typically 95%).</li>
                    <li><span class="list-label">Effect Size:</span> Magnitude of the difference or relationship, providing practical significance beyond statistical significance.</li>
                  </ul>
                </mat-expansion-panel>
              </div>
            </div>
            } -->
          </div>
        </div>
      </div>
    </div>
  </mat-dialog-content>
</div>
